var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"100vh","background-color":"#f7f8fa"}},[(_vm.show)?_c('Preview'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }